export const PRODUCT_KINDS = {
  INVESTMENT: "INVESTMENT",
  SAVINGS: "SAVINGS",
} as const;

export type ProductKind = (typeof PRODUCT_KINDS)[keyof typeof PRODUCT_KINDS];

/** A deal payload on the client, or an investable row on the server. */
export type ProductKindSource = object | null | undefined;

// Nothing on the investable names its product yet, so every deal is an investment.
export const resolveProductKind = (_source: ProductKindSource): ProductKind =>
  PRODUCT_KINDS.INVESTMENT;
